import { render } from "./NumberedBadge.vue?vue&type=template&id=168660e7"
import script from "./NumberedBadge.vue?vue&type=script&lang=js"
export * from "./NumberedBadge.vue?vue&type=script&lang=js"
script.render = render

export default script